/** Email allowlist for Data migration UI (sidebar + route). Compare case-insensitively. */
export const DATA_MIGRATION_ALLOWED_EMAILS = [
  "anushka.raut@otelier.io",
  "samriddhi.kaswa@otelier.io",
  "troy.spalding@otelier.io",
  "tara.wilson@otelier.io",
  "erin.powell@otelier.io",
  "rajiv.raval@otelier.io",
  "raven.adams@otelier.io",
  "russell.meek@otelier.io",
  "autumn.hood@otelier.io",
  "ankur.borda@otelier.io",
  "surbhi.jain@otelier.io",
  "sergey.pavlov@otelier.io",
  "nikunj.savaliya@otelier.io"
];

export function canAccessDataMigration(email) {
  if (email == null || typeof email !== "string") return false;
  const normalized = email.trim().toLowerCase();
  return DATA_MIGRATION_ALLOWED_EMAILS.some((e) => e.toLowerCase() === normalized);
}

/** Email allowlist for the Paired-daily dedup UI (sidebar + route) — a stricter subset. Compare case-insensitively. */
export const PAIRED_DAILY_DEDUP_ALLOWED_EMAILS = [
  "nimit.desai@otelier.io",
  "ankur.borda@otelier.io",
  "nikunj.savaliya@otelier.io",
  "surbhi.jain@otelier.io",
  "prudhviraj.tripuraneni@otelier.io"
];

export function canAccessPairedDailyDedup(email) {
  if (email == null || typeof email !== "string") return false;
  const normalized = email.trim().toLowerCase();
  return PAIRED_DAILY_DEDUP_ALLOWED_EMAILS.some((e) => e.toLowerCase() === normalized);
}
